import { render, staticRenderFns } from "./CultureCenter.vue?vue&type=template&id=a3b11daa&scoped=true"
import script from "./CultureCenter.vue?vue&type=script&lang=js"
export * from "./CultureCenter.vue?vue&type=script&lang=js"
import style0 from "./CultureCenter.vue?vue&type=style&index=0&id=a3b11daa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b11daa",
  null
  
)

export default component.exports